import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { UserProfile } from 'app/_models';
import { AuthenticationService } from 'app/_services';
import { CedNotificationService } from 'ced-ng-library';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WorkActivityOptionsModel } from '../work-activity-option.model';
import { WorkActivityOptionsService } from '../work-activity-options.service';

@Component({
  selector: 'app-work-activity-option-details',
  templateUrl: './work-activity-option-details.component.html',
  styleUrls: ['./work-activity-option-details.component.scss']
})
export class WorkActivityOptionDetailsComponent extends DialogContentBase implements OnInit,OnDestroy {
  public workActivityOptionForm = new FormGroup({});
  values = [{text:"Yes",id:0},{text:"No",id:1}];
  private _subject$: Subject<boolean> = new Subject();
  private selectedWorkActivityOption: WorkActivityOptionsModel = null;
  private profile: UserProfile = new UserProfile();
  constructor( dialog: DialogRef,
    private cedNotificationService: CedNotificationService,
    private authenticationService: AuthenticationService,
    private workActivityOptionsService: WorkActivityOptionsService) { 
    super(dialog)
  }

  ngOnInit() {
    this.initForm();
    this.populateControls();
  }
  initForm(){
    this.workActivityOptionForm = new FormGroup({
        code: new FormControl(null, Validators.required),
        shortName: new FormControl(null, Validators.required),
        longName: new FormControl(null, Validators.required),
        active: new FormControl(null, Validators.required)
    });
  }

  public save() {
    let workActivityOptions = new WorkActivityOptionsModel ();                
    workActivityOptions.aoCode = this.workActivityOptionForm.controls.code.value;
    workActivityOptions.aoShortName = this.workActivityOptionForm.controls.shortName.value;
    workActivityOptions.aoLongName =  this.workActivityOptionForm.controls.longName.value;
    workActivityOptions.aoInactive =  this.workActivityOptionForm.controls.active.value.id;
    if(this.workActivityOptionForm.valid){
        if(this.selectedWorkActivityOption == null){
          workActivityOptions. aoCreatedBy = this.profile.emailAddress;          
          workActivityOptions.aoLastModifiedBy = this.profile.emailAddress;            
            this.workActivityOptionsService
            .save(workActivityOptions)
            .pipe(takeUntil(this._subject$))
            .subscribe(
              (res:any) => {
                  this.dialog.close(workActivityOptions);
                  this.cedNotificationService.success("NOTIFICATIONS.SAVE_SUCCEDED");
              }
            )
        }
        else{
          workActivityOptions.aoId = this.selectedWorkActivityOption.aoId;      
          workActivityOptions.aoLastModifiedBy = this.profile.emailAddress;          
          this.workActivityOptionsService
          .update(workActivityOptions)
          .pipe(takeUntil(this._subject$))
          .subscribe(
            (res:any) => {

                this.dialog.close(this.selectedWorkActivityOption);
                this.cedNotificationService.success("NOTIFICATIONS.UPDATE_SUCCEDED");

            }
          )
        }
    } 
    else
    this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_DATA_MISSING")
}
populateControls(){
  if(this.selectedWorkActivityOption != null){
      this.workActivityOptionForm.controls.code.setValue(this.selectedWorkActivityOption.aoCode);
      this.workActivityOptionForm.controls.shortName.setValue(this.selectedWorkActivityOption.aoShortName);
      this.workActivityOptionForm.controls.longName.setValue(this.selectedWorkActivityOption.aoLongName);
      if(this.selectedWorkActivityOption.aoInactive == true){
        this.workActivityOptionForm.controls.active.setValue(this.values[1]);
      }else if(this.selectedWorkActivityOption.aoInactive == false){
        this.workActivityOptionForm.controls.active.setValue(this.values[0]);
      }
  }                                       
}
  public cancel() {
    this.dialog.close(null);
  } 

  ngOnDestroy(): void {
    this._subject$.next();
    this._subject$.complete();
  }
}
